import { useCallback, useState } from 'react'
import { useForm } from 'react-hook-form'
import PhoneInput from 'react-phone-number-input/react-hook-form-input'

export const Newsletter = () => {
  const { register, reset, handleSubmit, control } = useForm()
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState(false)

  const onSubmit = useCallback(
    async (data) => {
      setError(null)

      try {
        const response = await fetch('/api/klaviyo/marketing', {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
          },
        })

        if (response.status !== 200) {
          setError('Something went wrong, please try again')
          return
        }
        setSuccess(true)
        reset({
          email: '',
          phone: '',
        })
        setTimeout(() => {
          setSuccess(false)
        }, 5000)
      } catch (error: any) {
        setError(error?.message)
      }
    },
    [reset]
  )

  return (
    <div>
      <p className="max-w-[250px] pb-14 md:max-w-full">
        Keep updated with our news and latest batches by subscribing to our
        mailing list.
      </p>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col gap-8 text-11 leading-100 md:gap-[15px]"
      >
        <div className="flex gap-6 md:gap-20">
          <input
            className="flex-1 rounded-6 bg-lightGray px-20 py-10 uppercase placeholder-darkGray focus:outline-[#DEDEDE] md:py-24"
            placeholder="Your Email"
            type="email"
            {...register('email')}
          />
          <button
            type="submit"
            className="w-[112px] rounded-6 bg-yellow px-12 py-10 uppercase text-darkGray md:w-[200px] md:px-20 md:py-24"
          >
            Subscribe
          </button>
        </div>
        <div className="flex gap-6 md:gap-20">
          <PhoneInput
            name="phone"
            className="flex-1 rounded-6 bg-lightGray px-20 py-10 uppercase placeholder-darkGray focus:outline-[#DEDEDE] md:py-24"
            placeholder="Your Phone Number"
            control={control}
            country="US"
          />

          <button
            type="submit"
            className="w-[112px] rounded-6 bg-yellow px-12 py-10 uppercase text-darkGray md:w-[200px] md:px-20 md:py-24"
          >
            Get Updates
          </button>
        </div>
        {error ? <p>{error}</p> : null}
        {success ? <p>Thanks for subscribing!</p> : null}
      </form>
    </div>
  )
}
